import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { getIt } from "@uikit/getIt";
import { JsonUtil } from "imagica-corekit/dist/base/cutil/JsonUtil";
import { StudioProject } from "imagica-corekit/dist/base/project/domain/StudioProject";
import { PersonalFunctionStore } from "imagica-corekit/dist/base/store/PersonalFunctionStore";
import { StoryTransformer } from "imagica-corekit/dist/base/storyV2/Transformer/StoryTransformer";
import { Story } from "imagica-corekit/dist/base/storyV2/domain/Story";
import { EdgeState, StoryEdge } from "imagica-corekit/dist/base/storyV2/domain/StoryEdge";
import { StoryEventObject } from "imagica-corekit/dist/base/storyV2/domain/StoryEventObject";
import { StoryManager } from "imagica-corekit/dist/base/storyV2/domain/StoryManager";
import { StoryNode } from "imagica-corekit/dist/base/storyV2/domain/StoryNode";
import { StoryNodeState } from "imagica-corekit/dist/base/storyV2/domain/StoryNodeState";
import { StoryUtil } from "imagica-corekit/dist/base/storyV2/domain/StoryUtil";
import { chain, get, isArray } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import store from "../../store";
import { editorActions } from "../../store/editor";
import func from "@uikit/func";
import {
  COMPLETE_LINE_STYLE,
  COMPLETE_MARKER_END,
  EDGE_STATE_CONFIG,
  ERROR_LINE_STYLE,
  ERROR_MARKER_END,
  GROUPID_REG,
  NEW_EDGE_REG,
  TRANSPARENT_MARKER_END,
} from "../../views/thinking-layout-editor/constants";
import { Identifier } from "imagica-corekit/dist/base/api/IdentifierTyped/Identifier";
import { MeStore } from "imagica-corekit/dist/base/store/MeStore";
import { creatorRefStore } from "@uiview/views/ProjectCanvas/store/CreatorRefStore";
import { ViewBuilderService } from "imagica-corekit/dist/base/service/ViewBuilderService";
import { UploadService } from "imagica-corekit/dist/base/service/UploadService";
import { ViewBuilderData, ViewBuilderWorker } from "imagica-uikit/dist/nodesV2/ViewBuilderComponents/ViewBuilderWorker";
import { CorebeUtil } from "@uikit/corebe/CorebeUtil";
import { StudioProjectV3BluePrintValue } from "imagica-corekit/dist/base/project/domain/StudioProjectAttributesV3NodeData";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";
import { UpdateImgContextUtil } from "@uikit/util/UpdateImgContextUtil";
import { CreatorEdgesStore } from "@uiview/views/ProjectCanvas/store/CreatorEdgesStore";
import { CreatorStoreMethods } from "@uikit/service/CreatorStoreMethods";
import { HomeUsePluginUtil } from "@uikit/util/HomeUsePluginUtil";
import { previewStore } from "@uiview/store/PreviewStore";
import { CreatorSaasAppStore } from "@uiview/views/ProjectCanvas/store/CreatorSaasAppStore";
import { useHomeDeleteMethods } from "@uiview/views/ProjectCanvas/useHomeDeleteMethods";
import { useHomePreviewMethods } from "@uiview/views/ProjectCanvas/useHomePreviewMethods";
import { useStore as useImagincStore } from "imagica-uikit/dist/hooks/useStore";
import { myModificationDataStroe } from "@uiview/views/ProjectCanvas/store/MyModificationDataStroe";

type ArgsType = {
  getSaveData: <T>(templateObj: object, edges: any, variableList: any, params: object, updateParam: T) => object;
  handleCustomToGroup: (preNodeId: string, newNodeArr: Array<any>) => any;
  errorClosure?: (nodeOrEdge: StoryNode | StoryEdge) => void;
  handleGroupToCustom: (preNodeId: string, newNode: any) => any;
  handleSave: (data: any) => any;
};

// eslint-disable-next-line
export default function useNewEdgeRun({
  getSaveData,
  handleCustomToGroup,
  errorClosure,
  handleGroupToCustom,
  handleSave,
}: ArgsType) {
  const viewBuilderService = getIt(ViewBuilderService);
  const uploadService = getIt(UploadService);
  const creatorNodesStore = getIt(CreatorNodesStore);
  const creatorEdgesStore = getIt(CreatorEdgesStore);
  const creatorStoreMethods = getIt(CreatorStoreMethods);
  const creatorSaasAppStore = getIt(CreatorSaasAppStore);

  const myModificationDataState = useImagincStore(myModificationDataStroe).value;
  const homeDeleteMethods = useHomeDeleteMethods();
  const homePreviewMethods = useHomePreviewMethods();

  const dispatch = useDispatch();
  const getShowTooltip = useSelector((state: any) => state.editor.showTooltip);
  const setCloseToolTipArr = (val: any): void => {
    dispatch(editorActions.setCloseToolTipArr(val));
  };
  const setShowTooltip = (val: any): void => {
    dispatch(editorActions.setShowTooltip(val));
  };
  const setNeedDisableEdgeIds = (val: any): void => {
    dispatch(editorActions.setNeedDisableEdgeIds(val));
  };

  const setIsEdgeRunning = (val: any): void => {
    dispatch(editorActions.setIsEdgeRunning(val));
  };

  const homeStore = getIt(HomeStore);
  const featureTags: any = homeStore.state.featureTags;

  const getStory = <T>(edgeId?: string, updateParam?: T): any => {
    const templateObj = store.getState().studio.selectedTemplate;
    const edges = creatorEdgesStore.getEdges();
    const variableList = store.getState().fot.variableList;
    const data = getSaveData(templateObj, edges, variableList, {}, updateParam);
    const projectObj = {
      attributes: data,
      attrIndexer: (data as any).index || (templateObj as any).index,
      id: (templateObj as any).id,
    };
    const projectJsonStr = JsonUtil.stringify(projectObj);
    const project = JsonUtil.toModelFromType(StudioProject, projectJsonStr);
    if (!project)
      return {
        story: undefined,
        storyEdge: undefined,
      };
    const story = StoryUtil.from(project, true, creatorRefStore.nodeIndexRef.current);
    story.graphData = JsonUtil.parseFromInstance(data);
    getIt(PersonalFunctionStore).extractFuncs(project);
    if (func.isEmpty(edgeId))
      return {
        story,
        storyEdge: undefined,
      };

    const storyEdge = story
      .findAllEdges()
      .filter(x => x.options.id === edgeId)
      .first();
    return {
      story,
      storyEdge,
    };
  };
  const handleUIdata = (
    nodeId: string,
    getSimpleNodeData: (node: any) => any
  ): Record<string, any> | { data: any; id: string; type: string } => {
    const nodes = creatorNodesStore.getNodes();
    const currentNode = nodes.find(x => x.id === nodeId);
    if (func.isEmpty(currentNode)) return {};
    const data = getSimpleNodeData(currentNode);
    return {
      id: nodeId,
      type: currentNode?.type,
      data,
    };
  };

  type dataType = {
    id: string;
    type: string;
    data: any;
  };
  const updateNodeData = (updateNode: StoryNode, transformData: dataType | Array<dataType>): void => {
    const preNodeId = updateNode.options.id;
    if (typeof transformData === "object" && !Array.isArray(transformData)) {
      if (
        updateNode.id !== undefined &&
        updateNode.options.id !== updateNode.id &&
        updateNode.options.id.includes("group")
      ) {
        /// group变node
        const newData = transformData;
        newData.id = updateNode.id;
        handleGroupToCustom(preNodeId, newData);
        handleNodeAndEdgeRef([transformData]);
        handleToolTip([transformData], updateNode.state);
        return;
      }
      const object = transformData as dataType;
      if (func.isEmpty(object.id) || func.isEmpty(object.data)) return;
      creatorNodesStore.setNodes((prevList: any) => {
        return prevList.map((node: any) => {
          if (node.id === object.id) {
            const newData = {
              ...node,
              type: object.type,
              data: {
                ...node.data,
                ...object.data,
              },
            };
            newData.data.initCreateBlobUrl = object.data?.initCreateBlobUrl;
            return newData;
          }
          return node;
        });
      });

      handleNodeAndEdgeRef([transformData]);
      handleToolTip([transformData], updateNode.state);
    } else {
      handleCustomToGroup(preNodeId, transformData);
      handleNodeAndEdgeRef(transformData);
      handleToolTip(transformData, updateNode.state);
    }
  };

  const handleNodeAndEdgeRef = (transformData: Array<dataType>): void => {
    // x.data.nodeIndexRef 来自 homeUsePlugin nodeDataRef, 此处不在需要,可直接替换 creatorRefStore
    const customNode = transformData.filter(
      (x: any) => !func.isEmpty(x.data?.nodeIndexRef) || !func.isEmpty(x.data?.edgeIndexRef)
    );
    if (func.isEmpty(customNode)) return;
    const corekitNodeIndex = customNode[0].data.nodeIndexRef.current;
    const corekitEdgeIndex = customNode[0].data.edgeIndexRef.current;
    if (!isNaN(corekitNodeIndex) && corekitNodeIndex > creatorRefStore.nodeIndexRef.current)
      creatorRefStore.nodeIndexRef.current = corekitNodeIndex;
    if (!isNaN(corekitEdgeIndex) && corekitEdgeIndex > creatorRefStore.edgeIndexRef.current)
      creatorRefStore.edgeIndexRef.current = corekitEdgeIndex;
  };
  const updateLineState = (
    id: string,
    state: EdgeState,
    uselessLineIds: string[],
    lineId: {
      sourceIds: string[];
      target: string;
    }
  ): void => {
    if (func.isEmpty(id) || func.isEmpty(state)) return;
    // 修改line的状态
    creatorEdgesStore.setEdges((prevList: any) => {
      return prevList.map((edge: any) => {
        if (lineId.sourceIds.includes(edge.id) || edge.id === lineId.target) {
          let lineStyle =
            state === EdgeState.LOADING
              ? COMPLETE_LINE_STYLE
              : state === EdgeState.ERROR
              ? ERROR_LINE_STYLE
              : COMPLETE_LINE_STYLE;
          if (uselessLineIds.includes(edge.id)) {
            lineStyle = ERROR_LINE_STYLE;
          }
          return {
            ...edge,
            animated: state === EdgeState.LOADING,
            style: lineStyle,
            markerEnd: lineId.sourceIds.includes(edge.id)
              ? TRANSPARENT_MARKER_END
              : state === EdgeState.LOADING
              ? COMPLETE_MARKER_END
              : state === EdgeState.ERROR
              ? ERROR_MARKER_END
              : COMPLETE_MARKER_END,
            data: {
              ...edge.data,
              stateConfig:
                state === EdgeState.LOADING ? EDGE_STATE_CONFIG[EdgeState.COMPLETED] : EDGE_STATE_CONFIG[state],
            },
          };
        }
        return edge;
      });
    });
  };
  const updataEdgeRunDisable = (id: string, state: EdgeState): void => {
    const needDisableEdgeIds = store.getState().editor.needDisableEdgeIds;
    // 加载中或者完成
    if (state === EdgeState.LOADING || state === EdgeState.COMPLETED) {
      const closeRunDisable = needDisableEdgeIds.filter((x: any) => x !== id);
      setNeedDisableEdgeIds(closeRunDisable);
    }

    // 失败
    if (state === EdgeState.ERROR) {
      setNeedDisableEdgeIds([]);
    }
  };
  const updateEdgeState = (id: string, state: EdgeState, identifier?: Identifier, storyEdge?: StoryEdge): void => {
    if (func.isEmpty(id) || func.isEmpty(state)) return;
    // 修改边的状态及identifier(可选)
    creatorNodesStore.setNodes((prevList: any) => {
      return prevList.map((edge: any) => {
        if (edge.id === id) {
          return {
            ...edge,
            data: {
              ...edge.data,
              lineParam: {
                ...edge.data.lineParam,
                loading: state === EdgeState.LOADING,
                identifier: identifier ?? edge.data.lineParam.identifier,
                description: storyEdge?.options.actionData.description,
              },
            },
          };
        }
        return edge;
      });
    });
  };

  const updateEdgeBlueprintMessage = (id: string | undefined, message: string): void => {
    if (func.isEmpty(id) || func.isEmpty(message)) return;
    const newNodes = chain(creatorNodesStore.getNodes())
      .map(edge => {
        if (edge.id === id) {
          const blueprintMessages: string[] = get(edge, "data.blueprintMessages", []);
          if (message === "done" && blueprintMessages.includes("done")) {
            return edge;
          }
          blueprintMessages.push(message);
          return {
            ...edge,
            data: {
              ...edge.data,
              blueprintMessages,
            },
          };
        }
        return edge;
      })
      .value();
    creatorNodesStore.setNodes(newNodes);
  };

  const handleToolTip = (transformData: Array<dataType>, state: StoryNodeState): void => {
    //运行完后才显示toolTip
    if (state !== StoryNodeState.COMPLETED && state !== StoryNodeState.ERROR) return;
    if (getShowTooltip === "new-edge-2") {
      setCloseToolTipArr(["new-edge-2"]);
      const nodeStr = transformData.some((x: any) => x.id === "group-3") ? "group-3" : "editor-3";
      setShowTooltip(nodeStr);
    }
  };
  const handleViewBuilder = (param: {
    updateNode: any;
    transformData: any;
    onUpdateNode?: (args: any) => void;
  }): void => {
    let { transformData } = param;
    const { updateNode, onUpdateNode } = param;
    // 是group不执行
    if (isArray(transformData)) return;
    const isNodeCompleted = (updateNode.state as any) === EdgeState.COMPLETED;
    const currentNode = creatorNodesStore.getNodeById(transformData.id);
    const updateShareAppData = (viewBuilderData: ViewBuilderData): void => {
      // 这里重新赋值transformData的内容以便给share app更新
      transformData = {
        ...transformData,
        data: {
          ...transformData.data,
          // 如果run时显示的是text界面，那么这里闭包加入时showBuilderUI变量为false，需要更新为true，以便后续判定状态正确
          showBuilderUI: true,
          viewBuilderData: {
            ...transformData.data.viewBuilderData,
            ...viewBuilderData,
          },
        },
      };
      onUpdateNode?.({ updateNode, transformData });
    };

    // 如果已经显示view builder界面需要在text streaming时就显示loading
    if (transformData.data?.showBuilderUI && !currentNode?.data.viewBuilderData?.loadingHtml) {
      creatorStoreMethods.setNodeParam({
        id: transformData.id,
        data: {
          viewBuilderData: {
            loadingHtml: true,
            domList: [],
            originalText: transformData.data.textAreaValue,
          },
        },
      });
    }

    if (isNodeCompleted) {
      if (transformData.data?.displayType !== "text") return;
      // 显示view builder时直接请求数据并处理
      if (transformData.data.showBuilderUI) {
        if (currentNode?.data.viewBuilderData?.isRequestStart) return;
        new ViewBuilderWorker({
          id: transformData.id,
          textAreaValue: transformData.data.textAreaValue,
          viewBuilderService,
          uploadService,
          setNodes: creatorNodesStore.setNodes,
          updateShareAppData,
        }).getViewBuilderData();
      }
    }
  };
  const handleResolveRun = (param: {
    isRunAll: boolean;
    updateNode: any;
    transformData: any;
    resolve: (res?: any) => void;
    onUpdateNode?: (args: any) => void;
  }): void => {
    const { isRunAll, updateNode, transformData, resolve, onUpdateNode } = param;
    const isNodeCompleted = (updateNode.state as any) === EdgeState.COMPLETED;
    const showBuilderUI = ViewBuilderWorker.isShowBuilderUI(transformData?.data?.showBuilderUI ?? false);
    if (isNodeCompleted) {
      // 不显示view builder ui时，调用onUpdateNode
      if (!showBuilderUI) {
        //单个node
        if (typeof transformData === "object" && !Array.isArray(transformData)) {
          onUpdateNode?.({ updateNode, transformData });
        } else {
          updateGroupOutput(updateNode);
        }
      }
      if (!isRunAll) {
        resolve({
          updateNode,
          transformData,
        });
      }
    }
  };
  const updateGroupOutput = (updateNode: any): void => {
    //单个node到组，更新saasuidata中的groupId
    const preNodeId = updateNode.options.id;
    const output = creatorSaasAppStore.state.saasUIData.output.map((item: any) => {
      if (item.results[0]?.nodeId === preNodeId) {
        return { ...item, groupId: updateNode.id };
      }
      return item;
    });
    creatorSaasAppStore.setSaasUIData(prevData => {
      return {
        ...prevData,
        output,
      };
    });
    //更新preview中的group
    const allNode = creatorNodesStore.getNodes();
    HomeUsePluginUtil.updateGroupChildNode({
      groupId: updateNode.id,
      previewUI: previewStore.state.selectedUI,
      allNode,
      // bsf-4912 replace thoughts
      thoughts: output,
      // bsf-4912 use setSassUIData
      setSaasUIData: creatorSaasAppStore.setSaasUIData,
      handleDeleteGroupNodeByPreviewBtn: homeDeleteMethods.handleDeleteGroupNodeByPreviewBtn,
      addGroupNodeToPreview: homePreviewMethods.addGroupNodeToPreview,
    });
  };
  const listenContent = (params: {
    isRunAll: boolean;
    story: Story;
    getSimpleNodeData: (node: any) => any;
    resolve: (res?: any) => void;
    reject: (error?: any) => void;
    edgeId?: string;
    onUpdateNode?: (args: any) => void;
  }): void => {
    const { isRunAll, story, getSimpleNodeData, resolve, edgeId, onUpdateNode } = params;
    story.on((eventobject: any) => {
      // console.log("corekit story update");
      eventobject.elements.forEach((element: any) => {
        const updateNode = StoryEventObject.asNode(element);
        if (updateNode) {
          //group node，uiData传{}
          let uiData = {};
          // 更新image node的caption内容
          UpdateImgContextUtil.updateImgNodeContext(updateNode, story);
          if (!GROUPID_REG.test(updateNode.options.id) && !NEW_EDGE_REG.test(updateNode.options.id)) {
            const data = handleUIdata(updateNode.options.id, getSimpleNodeData);
            if (!func.isEmpty(data)) uiData = data;
          }
          // console.log("corekit node update", updateNode, uiData);
          const transformData = StoryTransformer.transform(uiData, updateNode, story);

          const textAreaValue = get(transformData, "data.textAreaValue") as unknown;
          /// 逐渐废弃 data.blueprintMessage 使用方式，统一在textAreaValue中获取
          const blueprintMessage =
            (textAreaValue as StudioProjectV3BluePrintValue)?.message ?? get(transformData, "data.blueprintMessage");
          if (blueprintMessage) {
            updateEdgeBlueprintMessage(edgeId, blueprintMessage);
          }

          updateNodeData(updateNode, transformData as dataType | Array<dataType>);
          // console.log("corekit transformData:", transformData);

          if (errorClosure !== undefined && updateNode.state === StoryNodeState.ERROR) {
            errorClosure(updateNode);
          }

          // onUpdateNode?.({ updateNode, transformData });
          if (
            (transformData as dataType)?.data?.showBuilderUI === false &&
            (transformData as dataType)?.data?.viewBuilderData
          ) {
            (transformData as dataType).data.viewBuilderData.domList = [];
          }
          handleViewBuilder({
            updateNode,
            transformData,
            onUpdateNode,
          });
          handleResolveRun({
            isRunAll,
            updateNode,
            transformData,
            resolve,
            onUpdateNode,
          });
        }

        const updateEdge = StoryEventObject.asEdge(element);
        if (updateEdge) {
          const useLessLine = getUselessLineIds(story, updateEdge);
          const identifier = {
            type: updateEdge.options.actionData.identifierType,
            value: updateEdge.options.actionData.identifierValue,
          };
          updataEdgeRunDisable(updateEdge.options.id, updateEdge.state);
          updateEdgeState(updateEdge.options.id, updateEdge.state, identifier, updateEdge);
          updateLineState(updateEdge.options.id, updateEdge.state, useLessLine, {
            sourceIds: updateEdge.options.source,
            target: updateEdge.options.target,
          });
          if (errorClosure !== undefined && updateEdge.state === EdgeState.ERROR) {
            errorClosure(updateEdge);
          }
          // console.log("corekit edge update:", updateEdge.options.id, updateEdge.state);
        }
      });
    });
  };

  /** 找到对于带/的边，无效输入的line id */
  function getUselessLineIds(story: Story, currentEdge: StoryEdge): string[] {
    const edgeText = currentEdge.options.actionData.enterText;
    let useSouceLines = currentEdge.options.source;
    /// 带/ 的边 并且有多个输入node
    if (edgeText.startsWith("/") && useSouceLines.length > 1) {
      // 获取sorcenode 和corekit中一样
      const usedSourceNode = StoryUtil.findEdgeSoure(story, currentEdge);
      useSouceLines = useSouceLines.filter(lineId => {
        return !usedSourceNode?.lines.find(nodeLine => {
          return nodeLine.options.id === lineId;
        });
      });
      return useSouceLines;
    }
    return [];
  }

  const corekitRun = async <T>(param: {
    getSimpleNodeData: (node: any) => any;
    edgeId?: string;
    updateParam?: T;
    isFromPreview?: boolean;
    isRunAll?: boolean;
    onUpdateNode?: (args: any) => void;
  }): Promise<Story | undefined> => {
    // 有featureTags且不是function界面的运行
    if (featureTags.enableGlobalContext && !myModificationDataState.showMyModification) {
      updateEdgeState(param.edgeId ?? "", EdgeState.IDLE);
      const saveResult = handleSave({ background: true });
      updateEdgeState(param.edgeId ?? "", EdgeState.LOADING);
      try {
        await saveResult;
      } catch (error) {
        console.warn(error);
      }
    }

    const meStore = getIt(MeStore);
    const hasCorebe = await meStore.hasCorebe();

    return new Promise((resolve: (res?: any) => void, reject: (error?: any) => void) => {
      const { getSimpleNodeData, edgeId, updateParam, isFromPreview = false, isRunAll = false, onUpdateNode } = param;
      const { story, storyEdge } = getStory(edgeId, updateParam);
      const storyManager: StoryManager = getIt(StoryManager);

      if (!story) return resolve();

      listenContent({
        isRunAll,
        story,
        getSimpleNodeData,
        resolve,
        reject,
        edgeId,
        onUpdateNode,
      });

      if (hasCorebe) {
        // CorebeUtil.runByStream(story);
        CorebeUtil.runBySocket(story);
        if (story) return resolve(story);
      }

      if (storyEdge) {
        setShowTooltip("close");
        storyManager.runEdge(story, storyEdge).finally(() => {
          setIsEdgeRunning(false);
          resolve(story);
        });
      } else {
        const needRunAll = !isFromPreview;
        const cleanContent = !needRunAll;
        storyManager.run(story, needRunAll, cleanContent).finally(() => {
          resolve(story);
          setIsEdgeRunning(false);
        });
      }
    });
  };

  const corekitRunStop = (projectId: string, edgeId: string): void => {
    if (func.isEmpty(edgeId)) return;
    const storyManager = getIt(StoryManager);
    storyManager.stop(projectId, edgeId);
    setIsEdgeRunning(false);
  };

  return {
    corekitRun,
    corekitRunStop,
    updateEdgeState,
  };
}
